import axios from 'axios';
import * as _ from 'lodash'

const xlsSignature = [0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1];

function readBlob(blob, mode) {
  return new Promise((resolve, reject) => {
    if (typeof FileReader === 'undefined') {
      reject(new Error('Leitura do arquivo não suportada pelo navegador.'));
      return;
    }
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
    mode === 'text' ? reader.readAsText(blob) : reader.readAsArrayBuffer(blob);
  });
}

function invalidReportError(statusCode) {
  const error = new Error('Resposta inválida ao exportar veículos.');
  error.exportStatusCode = statusCode;
  return error;
}

function readStatusCode(data) {
  if (data && data.status) return Promise.resolve(data.status.code);
  if (!data) return Promise.resolve(undefined);

  return readBlob(data, 'text').then(rawPayload => {
    try {
      const payload = JSON.parse(rawPayload);
      return payload && payload.status && payload.status.code;
    } catch (e) {
      return undefined;
    }
  });
}

class VehiclesService {

  exportVehicles(contractId) {
    return axios
      .get(`/v2/gerarRelatorioVeiculoExcel/${contractId}/relatorio_veiculos.xls`, { responseType: 'blob' })
      .then(res => {
        const responseType = res.headers && res.headers['content-type'] || res.data && res.data.type || '';
        const contentType = responseType.split(';')[0].trim().toLowerCase();
        const invalidTypes = ['application/json', 'text/html', 'text/plain'];

        // Erros de sessão da API também podem chegar como JSON com HTTP 200.
        if (!res.data || !res.data.size || invalidTypes.indexOf(contentType) !== -1) {
          if (res.data && contentType === 'application/json') {
            return readStatusCode(res.data).then(statusCode => {
              throw invalidReportError(statusCode);
            });
          }

          throw invalidReportError();
        }

        // O arquivo legado deve ser um XLS binário OLE. Como integrações antigas
        // podem omitir ou declarar o MIME incorretamente, validamos os bytes.
        return readBlob(res.data.slice(0, xlsSignature.length), 'buffer').then(buffer => {
          if (buffer) {
            const bytes = new Uint8Array(buffer);
            const validSignature = xlsSignature.every((value, index) => bytes[index] === value);
            if (!validSignature) throw invalidReportError();
          }
          return res.data;
        });
      })
      .catch(err => {
        // O interceptor legado rejeita diretamente o response normalizado.
        const response = err && (err.response || (err.status ? err : undefined));
        if (!response) throw err;

        const responseType = response.headers && response.headers['content-type'] || response.data && response.data.type || '';
        const contentType = responseType.split(';')[0].trim().toLowerCase();

        if (response.data && contentType === 'application/json') {
          return readStatusCode(response.data).then(statusCode => {
            err.exportStatusCode = statusCode;
            throw err;
          });
        }

        throw err;
      });
  }

  /**
   * Retorna os veiculos que precisam ser ativados
   *
   * @returns Promise<Object> Lista veiculos
   */
   getVehiclesForActivate() {
     return axios
       .get('/v2/getVehiclesForActivate').then(res=>{

         /*if(res.data.vehicleList && res.data.vehicleList.vehicle){
           return _.filter(res.data.vehicleList.vehicle, function(o){
               return _.find(o.plansEnabled.planEnabled, function(obj){
                 //retorna apenas os veiculos que não são dos planos RNTRC
                 return obj.planId != 2 && obj.planId != 3
               });
           });
         } */
         return res.data.vehicles;
       });
   }

   getVehiclesForActivateAgg() {
     return axios
       .get('/v2/getVehiclesForActivateAgg').then(res=>{
         return res.data.vehicles;
       });
   }

  getVehiclesForActivateByPlate(filter) {
    return axios.post(`/v2/getVehiclesForActivateByPlate`, filter).then(res => {
      return res.data.vehicles;
    });
  }

  /**
   * Retorna os veiculos que precisam ser ativados
   *
   * @returns Promise<Object> Lista veiculos
   */
  getVehiclesToVinculateRNTRC() {
    return axios
      .get('/v1/getVehiclesForActivate').then(res=>{
        /*
        if(res.data.vehicleList && res.data.vehicleList.vehicle){
          return _.filter(res.data.vehicleList.vehicle, function(o){
              return _.find(o.plansEnabled.planEnabled, function(obj){
                //retorna apenas os veiculos que não são dos planos RNTRC
                return obj.planId == 2 || obj.planId == 3
              });
          });
        }
        */
        return res.data.vehicleList.vehicle;
      });
  }

  /**
   * Retorna os veiculos do contrato
   *
   * @returns Promise<Object> Lista veiculos
   */
  getVehicleByContractId(contractId) {
    return axios
      .get(`/v1/getVehicleByContractId/${contractId}`)
      .then(res => {
        return res.data.vehicleList.vehicle;
      });
  }

  getVehicleByContractIdV2(contractId) {
    return axios
      .get(`/v2/getVehiclesByContractId/${contractId}`)
      .then(res => {
        return res.data;
      });
  }

    getVehicleByContractIdContagem(contractId) {
    return axios
      .get(`/v2/getVehiclesByContractId/${contractId}`)
      .then(res => {
        return res.data.Vehicles;
      });
  }

  getVehicleMercosulPlate(plate) {
    return axios
      .get(`/v2/getMercosulPlate/${plate}`)
      .then(res => {
        return res.data;
      });
  }

    alterToMercosulPlate(plate) {
    return axios
      .post(`/v2/alterPlateMercosul`,{plate: plate})
      .then(res => {
        return res.data;
      });
  }

  getVehicle(filter) {
    return axios
      .post(`/v2/getVehicleSimplePaged`, filter)
      .then(res => {
        return res.data;
      });
  }

  getVehicleById(id) {
    return axios
      .get(`v2/getVehiclebyId/${id}`)
      .then(res => {
        return res.data.vehicle;
      });
  }

  getVehicleBrand() {
    return axios
      .get('/v2/getVehicleBrand')
      .then(res => {
        return res.data.brands;
      });
  }

    listaEixosBase(categoryId, token) {
    return axios
      .get(`/v2/netrim/listaEixosBase/${categoryId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(res => {
        return res.data.Axes;
      });
  }

  async getPlacaNetrim(plate, token) {
    const response = await axios
      .get(`/v2/netrim/getPlacaNetrim/${plate}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(res => {
        return res.data;
      });
    return response;
  }


  async postAxes(brand, model, fipeId, token) {
    const response = await axios
      .post(`/v2/netrim/listaEixosProc`, {
        marca: `${brand}`,
        modelo: `${model}`,
        fipe: `${fipeId}`
      }, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(res => {
        return res.data;
      });
    return response;
  }

  getVehicleModel(brandId) {
    return axios
      .get(`/v2/getVehicleModel/${brandId}`)
      .then(res => {
        return res.data.models;
      });
  }

    getContractUserList(moveMaisId) {
    return axios
      .get(`/v2/getContractUserList/${moveMaisId}`)
      .then(res => {
        return res.data.response;
      });
  }

  updateVehicle(enabledPap,vehicleId) {
    return axios.post(`/v2/updateVehicle2/${enabledPap}/${vehicleId}`).then(res => {
    // return axios.post(`/v2/newProcess/p1299`, data).then(res => {
      return res.data
    }).catch(res=>{
      return res.data.status;
    });
  }


  /**
   * Busca os veículos de um contrato
   *
   * @param filter Objeto com parametros de filtro
   * @param filter.contractId o id do contrato
   * @param {Page} filter.page objeto de paginação
   *
   * @return {Vehicles''}
   */
  find(filter) {
    let f = filter;
    let url = `/v1/getVehicleByContractIdPaged/${f.contractId}/${f.page.size()}/${f.page.page()}`;

    return axios.get(url)
      .then(res => {
        return res.data
      })
  }

  /**
   * Busca as passagens de um veículo
   *
   * @param filter Objeto com parametros de filtro
   * @param filter.vehicletId o id do vehicle
   * @param filter.start inicio do periodo
   * @param filter.end o fim do periodo
   * @param {Page} filter.page objeto de paginação
   *
   * @return {Vehicles''}
   */
  listPassage(filter) {
    let f = filter;
    let url = `/v2/listPassage/${f.contractId}/${f.vehicleId}/${f.startDate}/${f.endDate}`;
    return axios.get(url)
      .then(res => {
        return res.data
      })
  }
   /**
   * Busca veículo pela placa
   *
   * @param placa a ser pesquisada
   *
   * @return {Vehicles''}
   */
  getVehicleByPlateAndContract(plate, contractId) {
    let url = `/v1/getVehicleByPlateAndContract/${plate}/${contractId}`;

    return axios.get(url)
      .then(res => {
        return res.data
      })
  }

  /**
   * Busca veículo pelo OBUID (public tag)
   *
   * @param obuid a ser pesquisado
   *
   * @return {Vehicles''}
   */
  getByObuid(obuid) {
    let url = `/v1/getVehicleByPublicId/${obuid}`;

    return axios.get(url)
      .then(res => {
        return res.data
      })
  }

  vehicleNotExists(plate){
    return axios.get(`/v2/vehicleNotExists?plate=${plate}`)
      .then(r => true).catch(err => {
        const status = err && err.response ? err.response.status : err && err.status;
        if(status == 488)
          return false;

        //retorna true se nao consegui validar para nao bloquear o cadastro
        return true;

      });
  }

  checkVehicleByMoveMaisId(moveMaisId){
    return axios.get(`/v2/checkVehicleByMoveMaisId/${moveMaisId}`)
      .then(res => {

        return res.data
      });
  }

  deleteAggregateVehicleAndUser(filter) {
    return axios.post(`/v2/deleteAggregateVehicleAndUser`, filter).then(res => {
      return res.data
    });
  }

  getVehiclesAggregate(filter) {
    return axios.post(`/v2/getVehiclesAggregate`, filter).then(res => {
      return res.data
    });
  }

  getVehiclesAggregateWithBalance(filter) {
    return axios.post(`/v2/getVehiclesAggregateWithBalance`, filter).then(res => {
      return res.data
    });
  }

  createVehicleGrouper(vehicleId,idAgrupadorCliente) {
    return axios.post(`/v2/agrupadorVPO/createVeiculoAgrupador`, {
      idAgrupadorCliente,
      vehicleId
    }).then(res => {
      return res.data
    });
  }


}

// Singleton
const instance = new VehiclesService();
export default instance;



// WEBPACK FOOTER //
// ./src/services/vehicles.js